import PropTypes from 'prop-types';
import React from 'react';
import { Card, CardBody } from 'reactstrap';

import Switch from '../../../common/Switch';

/**
 * Card shell matching AddressCard footprint; holds the separate-delivery switch
 * when delivery is not split from billing (logged-in checkout).
 */
const RecipientSeparateDeliveryCard = ({
  checked,
  onChange,
  disabled,
  label,
}) => (
  <div className="RecipientSeparateDeliveryCard">
    <Card className="RecipientSeparateDeliveryCard__card">
      <CardBody className="RecipientSeparateDeliveryCard__body">
        <div className="RecipientSeparateDeliveryCard__switch-wrap">
          <Switch
            checked={checked}
            onChange={onChange}
            size="xs"
            disabled={disabled}
          >
            {label}
          </Switch>
        </div>
      </CardBody>
    </Card>
  </div>
);

RecipientSeparateDeliveryCard.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.node.isRequired,
};

RecipientSeparateDeliveryCard.defaultProps = {
  disabled: false,
};

export default RecipientSeparateDeliveryCard;
